import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { ApplicationState } from '../../../store';
import * as PropTypes from 'prop-types';
import moment from 'moment/moment';
import * as ModalActions from '../../../store/global/modal/actions';
import { DateFormat } from '../../../store/pages/venues/types';
import StockInventoryList from './stockLevelOverview';
import { clickHandler } from '../../../utils/util';
import StockProductManualRestock from './stockProductManualRestock';
import * as ct from '../../global/controls';
import * as v from '../../global/validation';
import ProductStockOverviewModal from './productStockOverviewModal';

interface MappedReduxState {
    selectedVenueId: string;
    dateFormat: DateFormat;
}

interface Actions {
    showModal: (overlayComponent: JSX.Element, screenName: string, noScroll?: boolean) => void;
    closeModal: () => void;
}

type StockOverviewPageProps = MappedReduxState & Actions;

interface StockOverviewPageState {
    lastUpdated: moment.Moment;
    filterProduct: ct.FormValue<string>;
    filterDate: ct.FormValue<moment.Moment>;
}

class StockOverviewPage extends React.Component<StockOverviewPageProps, StockOverviewPageState> {
    constructor(props: StockOverviewPageProps) {
        super(props);
        this.state = this.buildStateFromProps(props);
    }

    static contextTypes = {
        t: PropTypes.func
    }

    componentDidUpdate(prevProps: StockOverviewPageProps) {
        const { selectedVenueId } = prevProps;
        const { selectedVenueId: nextSelectedVenueId } = this.props;

        const hasVenueChanged = selectedVenueId !== nextSelectedVenueId;
        
        if (hasVenueChanged) {
            this.setState(this.buildStateFromProps(this.props));
        }
    }

    private buildStateFromProps(props: StockOverviewPageProps): StockOverviewPageState {
        return {
            lastUpdated: moment(),
            filterProduct: this.validateFilterProduct(''),
            filterDate: this.validateFilterDate(moment().add(7, 'd').startOf('day')),
        };
    }
    
    onSelectedProductChanged = (productId: string, productVariantId: string | null) => {
        console.log(productId, productVariantId)
        this.showProductStockOverviewModal(productId, productVariantId);
    }
    
    showProductStockOverviewModal = (productId: string, productVariantId: string | null) => {
        const { showModal, closeModal } = this.props;
        
        showModal(<ProductStockOverviewModal
            productId={productId}
            productVariantId={productVariantId}
            close={() => this.setState({lastUpdated: moment()}, closeModal)}
        />, 'ProductStockOverviewModal');
    }

    showManualRestock = () => {
        const { showModal } = this.props;

        const onClose = () => {
            const { closeModal } = this.props;
            closeModal();
            this.setState({lastUpdated: moment()});
        }
        
        showModal(<StockProductManualRestock
            close={onClose} 
        />, 'StockProductManualRestock');
    }

    validateFilterProduct = (val: string) => v.validate(val, 'filterProduct', [], []);
    validateFilterDate = (val: moment.Moment) => v.validate(val, 'filterDate', [], []);

    onFilterProductChanged = (searchTerm: string) => {
        this.setState({ filterProduct: this.validateFilterProduct(searchTerm) });
    }

    onFilterDateChanged = (date: moment.Moment) => {
        this.setState({ filterDate: this.validateFilterDate(date) });
    }

    render() {
        const { t } = this.context;
        const { selectedVenueId, dateFormat } = this.props;
        const { filterProduct, filterDate, lastUpdated } = this.state;

        return <>
            <header className='section-header'>
                <div className='page-heading'>
                    <h1 className='stockoverview_title'>{t('StockOverviewPage:title')}</h1>
                </div>
            </header>
            <div>
                <button className='btn btn-primary' onClick={e => clickHandler(e, () => this.showManualRestock())}>{t('StockOverviewPage:addStock')}</button>    
            </div>
            <div className='row' style={{marginTop: '20px'}}>
                <div className='col-md-3 col-xs-4'>
                    <ct.TextBox id='filterProduct' labelKey='StockOverviewPage:filterProduct' value={filterProduct} callback={this.onFilterProductChanged} />
                </div>
                <div className='col-md-3 col-xs-4'>
                    <ct.DatePicker id='filterDate' labelKey='StockOverviewPage:filterDate' value={filterDate} callback={this.onFilterDateChanged} dateFormat={dateFormat} timeFormat={undefined} />
                </div>
            </div>

            <StockInventoryList
                venueId={selectedVenueId}
                key={lastUpdated.toString()}
                dateFormat={dateFormat}
                filterSearchTerm={filterProduct.value}
                selectedDate={filterDate.value}
                onSelectedProductChanged={this.onSelectedProductChanged}
            />
        </>
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        selectedVenueId: state.venues.selectedVenueId,
        dateFormat: state.venues.dateFormat,
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    showModal: bindActionCreators(ModalActions.actionCreators.showModal, dispatch),
    closeModal: bindActionCreators(ModalActions.actionCreators.closeModal, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(StockOverviewPage);
